import * as t from  './actionTypes';
import * as api from './api';

export function loadShard() {

    return (dispatch) => {
        dispatch({ type: t.SET_BUSY });

        api.getShard((success, shard, error) => {
            if (success) {
                dispatch({ type: t.SHARD_LOAD_SUCCESS, shard: shard });
                dispatch({ type: t.UNSET_BUSY });
            } else if (error) {
                dispatch({ type: t.UNSET_BUSY });
            }
        });
    }
}

export function setShard(shard, successCB, errorCB) {
    return (dispatch) => {
        dispatch({ type: t.SET_BUSY });
        api.setShard(shard, function(success, shard, error) {
            if (success) {
                dispatch({ type: t.SHARD_CHANGE_SUCCESS, shard: shard });
                dispatch({ type: t.UNSET_BUSY });
            } else if (error) {
                dispatch({ type: t.UNSET_BUSY });
            }
        });
    }
}

export function createNewShard(data, successCB, errorCB) {
    return (dispatch) => {
        dispatch({ type: t.SET_BUSY });

        api.createNewShard(data, function(success, data, error) {
            if (success) {
                dispatch({ type: t.SHARD_CREATE_SUCCESS, shard: data });
                dispatch({ type: t.UNSET_BUSY });
                successCB();
            } else if (error) {
                dispatch({ type: t.UNSET_BUSY });
                errorCB(error);
            }
        })
    }
}

export function editShard(id, data, successCB, errorCB) {
    return (dispatch) => {
        dispatch({ type: t.SET_BUSY });

        api.editShard(id, data, function(success, data, error) {
            if (success) {
                dispatch({ type: t.SHARD_EDIT_SUCCESS, id: id, shard: data });
                dispatch({ type: t.UNSET_BUSY });
                successCB();
            } else if (error) {
                dispatch({ type: t.UNSET_BUSY });
                errorCB(error);
            }
        })
    }
}

export function deleteShard(id, successCB, errorCB) {
    return (dispatch) => {
        dispatch({ type: t.SET_BUSY });

        api.deleteShard(id, function(success, error) {
            if (success) {
                dispatch({ type: t.SHARD_DELETE_SUCCESS, id: id });
                dispatch({ type: t.UNSET_BUSY });
                successCB();
            } else if (error) {
                dispatch({ type: t.UNSET_BUSY });
                errorCB(error);
            }
        })
    }
}
